// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/PrerequisiteCard.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, bodyTextStyle, displayValue, humanize } from "./ExecutionSummaryCard";

function stateSymbol(state) {
  const normalized = String(state || "").toLowerCase();
  if (normalized === "ready") return "✓";
  if (normalized === "blocked") return "!";
  return "⚠";
}

export default function PrerequisiteCard({ prerequisites = [] }) {
  if (!Array.isArray(prerequisites) || prerequisites.length === 0) {
    return <EmptyPanel title="No prerequisite signals" message="Prerequisite readiness has not been generated for this task yet." />;
  }

  const blockers = prerequisites.filter((item) => item?.state === "blocked").length;
  const warnings = prerequisites.filter((item) => item?.state === "warning").length;

  return (
    <ExecutionPlanSection eyebrow="Readiness" title="Prerequisites" badge={blockers ? `${blockers} blocker` : warnings ? `${warnings} review` : "ready"}>
      <div style={{ display: "grid", gap: 10 }}>
        {prerequisites.map((item, index) => (
          <div key={`${item?.key || "prereq"}-${index}`} style={{
            display: "grid",
            gridTemplateColumns: "28px 1fr auto",
            gap: 10,
            alignItems: "start",
            border: "1px solid rgba(148, 163, 184, 0.16)",
            borderRadius: 14,
            padding: 12,
            background: "rgba(2, 6, 23, 0.24)",
          }}>
            <strong style={{ color: item?.state === "ready" ? "#86efac" : item?.state === "blocked" ? "#fecaca" : "#fde68a" }}>{stateSymbol(item?.state)}</strong>
            <div>
              <strong style={{ color: "#f8fafc", display: "block", fontSize: 13 }}>{displayValue(item?.label)}</strong>
              <p style={bodyTextStyle}>{displayValue(item?.detail, "No detail returned.")}</p>
            </div>
            <span style={{ color: "#93c5fd", fontSize: 11, fontWeight: 850 }}>{humanize(item?.state)}</span>
          </div>
        ))}
      </div>
    </ExecutionPlanSection>
  );
}
